import React from 'react';

import connectSubsection from 'components/Section/shared/SubsectionConnector';
import { IDENTIFICATION, IDENTIFICATION_REVIEW } from 'config/formSections/identification';
import { isPVQForm } from 'helpers/form';
import ApplicantName from './ApplicantName';
import ApplicantBirthDate from './ApplicantBirthDate';
import ApplicantBirthPlace from './ApplicantBirthPlace';
import ApplicantSSN from './ApplicantSSN';
import OtherNames from './OtherNames';
import ContactInformation from './ContactInformation';
import Physical from './Physical';

const sectionConfig = {
  section: IDENTIFICATION.name,
  store: IDENTIFICATION.store,
  subsection: IDENTIFICATION_REVIEW.name,
};

const Review = function (props) {
  const { formType } = props;
  const subsectionProps = {
    required: true,
    scrollIntoView: false,
  };

  const sectionDivider = <hr className="section-divider" />;
  const isPVQ = isPVQForm(formType);

  return isPVQ ? (
    <div>
      <ApplicantName {...subsectionProps} />
      {sectionDivider}
      <ApplicantBirthDate {...subsectionProps} />
      {sectionDivider}
      <ApplicantBirthPlace {...subsectionProps} />
      {sectionDivider}
      <ApplicantSSN {...subsectionProps} />
      {sectionDivider}
      <OtherNames {...subsectionProps} />
      {sectionDivider}
      <ContactInformation {...subsectionProps} shouldFilterEmptyItems isReview />
    </div>
  ) : (
    <div>
      <ApplicantName {...subsectionProps} />
      {sectionDivider}
      <ApplicantBirthDate {...subsectionProps} />
      {sectionDivider}
      <ApplicantBirthPlace {...subsectionProps} />
      {sectionDivider}
      <ApplicantSSN {...subsectionProps} />
      {sectionDivider}
      <OtherNames {...subsectionProps} />
      {sectionDivider}
      <ContactInformation {...subsectionProps} shouldFilterEmptyItems isReview />
      {sectionDivider}
      <Physical {...subsectionProps} />
    </div>
  );
};

export default connectSubsection(Review, sectionConfig);
